module.exports = __webpack_public_path__ + "img/icon-pos-terminal-white.5b6f6247.png";